export const DEFAULT_PAGE_SIZE = 100;
export const MAX_PAGINATION_PAGES = 100;
export const DEFAULT_PRICE_UNIT = "VND";
export const EXCHANGE_RATE_VND_TO_USD = 25000;
export const FALLBACK_IMAGE = "/no-image.jpg";
export const PRODUCTS_VISIBLE_INCREMENT = 6;
export const MAX_IMAGE_SIZE_MB = 5;
export const ALLOWED_IMAGE_TYPES = [
  "image/jpeg",
  "image/png",
  "image/webp",
  "image/gif",
];

export const PRODUCT_STATUSES = [
  "TRACKER",
  "UNLIMITED",
  "PRE_ORDER",
  "OUT_OF_STOCK",
] as const;

export const PAYMENT_METHODS = ["CONTACT", "PAYOS"] as const;
export const WARRANTY_UNITS = ["DAY", "MONTH", "YEAR"] as const;

export const DEFAULT_CATEGORIES = [
  "Dinh dưỡng & Thực phẩm bổ sung",
  "Đồ uống thể thao",
  "Dụng cụ tập luyện",
  "Thời trang",
  "Khác",
];
